<div class="container">
  <div class="header-time">
    <button class="btn" id="calendar-btn-back" (click)="clickBack()">
      <img src="../../../../assets/svgs/arrow_left.svg" alt="Seta ">      
    </button>
    <div class="month-year-container">
      <p class="year">{{ month }} {{ activeViewYear }}</p>
    </div>
    <button class="btn" id="calendar-btn-next" (click)="clickNext()">
      <img src="../../../../assets/svgs/arrow_right_ico.svg" alt="Seta proxima">
    </button>
  </div>
  <div class="month-header">
    <p *ngFor="let wDay of weekDays">{{ wDay }}</p>
  </div>
  <div class="week" *ngFor="let week of viewMonth.weeks; let i = index">
    <div class="day" *ngFor="let weekDay of week.days" id="{{'cld' + '-' + month + '-' + i + '-' + weekDay.day }}" 
    [ngClass]="{'now': !weekDay.notActive && weekDay.day == activeDay && weekDay.month === activeMonth}" 
    (click)="clickDay(weekDay)">
      <p [ngClass]="{'gray': weekDay.notActive}">{{ weekDay.day }}</p>
      <div class="today"></div>
    </div>
  </div>
</div>